import { initials, avatarClass } from './helpers';

interface AvatarProps {
  name: string;
  /** '' (default), 'sm', or 'lg' */
  size?: '' | 'sm' | 'lg';
}

/** Coloured-initials avatar. Warm tint is chosen deterministically from the name. */
export function Avatar({ name, size = '' }: AvatarProps) {
  return (
    <div className={`avatar ${size} ${avatarClass(name)}`.trim()} aria-hidden="true">
      {initials(name)}
    </div>
  );
}
